import { SlotRenderEndedSubjectData } from "@repo/lib-domain-tag/src/ads/eventSubjects/slotRenderEndedSubject.ts"
import { DomainSubjectCallback } from "@repo/lib-domain-tag";

export const fixPageSkinCssClass: DomainSubjectCallback<SlotRenderEndedSubjectData> = (data) => {
    if (data && data.isEmpty === false && (data.divId === 'div-sozcu_anasayfa_pageskin_tepe' || data.divId === 'div-sozcu_gen_pageskin_tepe')) {
        document.body.classList.add("pageskinTrue");
    }
}

export const displayDivDesktopIndexStickyParent: DomainSubjectCallback<SlotRenderEndedSubjectData> = (data) => {

    if (data && data.isEmpty === false && data.divId === 'div-sozcu_desktop_anasayfa_sticky') {
        const divParent = document.getElementById("div-sozcu_desktop_anasayfa_sticky_parent")
        if (divParent) {
            divParent.classList.add("bg-light");
        }
    }
    else  if (data && data.isEmpty === false && data.divId === 'div-sozcu_mobile_post_sticky_parent') {
        const divParent = document.getElementById("div-sozcu_mobile_detay_320x50_sticky")
        if (divParent) {
            divParent.classList.add("bg-light");
        }
    }
}

 